__turbopack_context__.v({
  "container": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__container",
  "contentColumn": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__contentColumn",
  "contentLayer": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__contentLayer",
  "detailScroll": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__detailScroll",
  "enter": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__enter",
  "exit": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__exit",
  "fade-in": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__fade-in",
  "fade-out": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__fade-out",
  "fade-out-80": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__fade-out-80",
  "headerBlock": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__headerBlock",
  "headerInner": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__headerInner",
  "heading": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__heading",
  "headingSecondary": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__headingSecondary",
  "headline": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__headline",
  "headlineLine": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__headlineLine",
  "highlight": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__highlight",
  "mainBlock": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__mainBlock",
  "mainGrid": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__mainGrid",
  "mediaColumn": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__mediaColumn",
  "section": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__section",
  "showcase": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__showcase",
  "showcaseVideo": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__showcaseVideo",
  "slide-in-from-bottom": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-in-from-bottom",
  "slide-in-from-left": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-in-from-left",
  "slide-in-from-right": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-in-from-right",
  "slide-in-from-top": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-in-from-top",
  "slide-out-to-bottom": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-out-to-bottom",
  "slide-out-to-left": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-out-to-left",
  "slide-out-to-right": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-out-to-right",
  "slide-out-to-top": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__slide-out-to-top",
  "step": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__step",
  "stepBody": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__stepBody",
  "stepConnector": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__stepConnector",
  "stepDescription": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__stepDescription",
  "stepNumber": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__stepNumber",
  "stepTitle": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__stepTitle",
  "stepsList": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__stepsList",
  "tabButton": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabButton",
  "tabContent": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabContent",
  "tabIndicator": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabIndicator",
  "tabIndicatorFill": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabIndicatorFill",
  "tabLabel": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabLabel",
  "tabLabelActive": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabLabelActive",
  "tabsBlock": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabsBlock",
  "tabsDivider": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabsDivider",
  "tabsInner": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabsInner",
  "tabsRow": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabsRow",
  "tabsScroller": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tabsScroller",
  "tag": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tag",
  "tagList": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__tagList",
  "zoom-in": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__zoom-in",
  "zoom-out": "SecFeatureDetailTabs-module-scss-module__9Kq3cG__zoom-out",
});
